import IconCircleCheck from 'approot/shared/icons/icon-circle-check';
import IconCircleCross from 'approot/shared/icons/icon-circle-cross';
import { Box } from 'approot/shared/design-system/box/box.style';

type Props = {
  hasAltText?: boolean | null;
  isShortLabel?: boolean;
};

const ComponentAltTextLabel = ({ hasAltText, isShortLabel }: Props) => (
  <Box $alignItems="center">
    {hasAltText ? (
      <>
        <IconCircleCheck width={16} height={16} />
        <Box $marginLeft={4}>{isShortLabel ? 'Alt' : 'Alt Text'}</Box>
      </>
    ) : (
      <>
        <IconCircleCross width={16} height={16} />
        <Box $marginLeft={4}>{isShortLabel ? 'Alt' : 'Alt Text'}</Box>
      </>
    )}
  </Box>
);

export default ComponentAltTextLabel;
